module.exports = __webpack_public_path__ + "img/gn.0798100e.svg";